'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactDom = require('react-dom');



Object.keys(reactDom).forEach(function (k) {
	if (k !== 'default') Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () {
			return reactDom[k];
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./~/@risingstack/react-easy-state/dist/react-platform.cjs.js
// module id = 1073
// module chunks = 0